import { render, staticRenderFns } from "./WorstScoresTableCard.vue?vue&type=template&id=3c40d5e3&"
import script from "./WorstScoresTableCard.vue?vue&type=script&lang=js&"
export * from "./WorstScoresTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports